export const LAYOUT_SECTION_MARGIN = 8;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const LAYOUT_COLUMN_PADDING: number = LAYOUT_SECTION_MARGIN * 1.5;
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const DEFAULT_TWO_COLUMN_LAYOUT_COLUMN_WIDTH = 50;
